"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitApplyRequest = void 0;
var SubmitApplyRequest = /** @class */ (function () {
    function SubmitApplyRequest() {
    }
    return SubmitApplyRequest;
}());
exports.SubmitApplyRequest = SubmitApplyRequest;
//# sourceMappingURL=submitApply.request.js.map